var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.classList},[_vm._t("prepend"),_vm._v(" "),_c('input',{ref:"autocompleteInput",staticClass:"form-control",attrs:{"id":"pac-input","type":"text","name":"address","value":"","placeholder":_vm.$t('coverage.map.searchInput')}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }